import { render, staticRenderFns } from "./HomeFeedDoubleMenu.vue?vue&type=template&id=77ff67bc&scoped=true"
import script from "./HomeFeedDoubleMenu.vue?vue&type=script&lang=js"
export * from "./HomeFeedDoubleMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ff67bc",
  null
  
)

export default component.exports